import { Brain } from 'lucide-react';
import InteligenciaDeInventario from '../inteligencia/InteligenciaDeInventario';

/* =====================================================================
   Las pantallas del carril `inteligencia` · DIRECTRIZ-INTELIGENCIA-DE-INVENTARIO
   =====================================================================
   «Inteligencia de inventario» va en Operación: es donde se decide qué
   pedir y dónde acomodar. La ve un encargado (permiso inteligencia.ver);
   las piezas de la ficha del producto, la recepción y la terminal las
   monta el integrador desde `src/inteligencia/`.
   ===================================================================== */
export default {
  orden: 66,
  grupos: [{
    grupo: 'Operación',
    items: [
      { id: 'inteligencia', etiqueta: 'Qué comprar y dónde ponerlo', icono: Brain, min: 'ENCARGADO', soloEmpresa: true, Comp: InteligenciaDeInventario },
    ],
  }],
};
